<template>
  <div class="find-icons">
    <template v-if="showVip">
      <div class="icon-item" v-stat="{id: 10296, args: {position: 'find2', type: 0}}" @click="toVideoMiddle">
        <img src="https://ndmicro-tmd.oss-cn-beijing.aliyuncs.com/resource/discoverIcon/icon_shipinhuiyuan%402x.png" class="item-icon">
        <div class="item-text">视频会员</div>
      </div>
      <div class="icon-item" v-stat="{id: 10296, args: {position: 'find2', type: 1}}" @click="$router.push('/vip/index')">
        <img src="https://ndmicro-tmd.oss-cn-beijing.aliyuncs.com/resource/discoverIcon/yijiantie%402x.png" class="item-icon">
        <div class="item-text">一键提额</div>
      </div>
    </template>
    <div class="icon-item" v-stat="{id: 10296, args: {position: 'find2', type: 2}}" @click="jumpAuth">
      <img src="https://ndmicro-tmd.oss-cn-beijing.aliyuncs.com/resource/discoverIcon/daiqianbicha%402x.png" class="item-icon">
      <div class="item-text">贷前必查</div>
    </div>
    <div class="icon-item" v-stat="{id: 10296, args: {position: 'find2', type: 3}}" @click="$router.push('/river/diversion')">
      <img src="https://ndmicro-tmd.oss-cn-beijing.aliyuncs.com/resource/discoverIcon/remenchanpin%402x.png" class="item-icon">
      <div class="item-text">热门产品</div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'FindQuickList',
  props: {
    showVip: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapActions('user', ['getUserInfoX']),
    toVideoMiddle () {
      this.$router.push(`/video/middle?from=${encodeURIComponent(location.href)}`)
    },
    // 跳转授信流程
    async jumpAuth () {
      const { authStatus = [] } = await this.getUserInfoX()
      if (!authStatus.includes('OCR')) {
        this.$router.push('/authentication/id')
      } else if (!authStatus.includes('INFO')) {
        this.$router.push('/authentication/base')
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.find-icons{
  display: flex;
  // justify-content: space-between;
  padding: 50px 54px;
  .icon-item{
    width: 25%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .item-icon{
      width: 96px;
      height: 96px;
    }
    .item-text{
      font-size: 28px;
      color: #333333;
      margin-top: 15px;
    }
  }
}
</style>